import { MAX_VALUE_16BITS } from "@linways/table-to-excel";
import _ from "lodash";
import moment from 'moment';
/*
    * This file is part of Lodgiq - Product Restriction Module.
    * This will have collections of functions related to product restrictions.
*/

/*
  * This function sor the rooms summary data of bucket in order of room types available
*/
export const sortRoomSummary = (buckets, sortOrder) => {
  return buckets.map(bucket => {
    if (bucket.rooms_summary) {
      bucket.rooms_summary.sort((a, b) => {
        const ai = sortOrder.indexOf(a.room_type_code);
        const bi = sortOrder.indexOf(b.room_type_code);
        return ai - bi;
      });
    }
    // If rate plans exist, sort their rooms_summary as well
    if (bucket.rate_plans) {
      bucket.rate_plans.forEach((ratePlan, i) => {
        bucket.rate_plans[i].rooms_summary.sort((a, b) => {
          const ai = sortOrder.indexOf(a.room_type_code);
          const bi = sortOrder.indexOf(b.room_type_code);
          return ai - bi;
        });
      });
    }
    // bucket.rooms_summary.sort((a, b) => a.room_type_code.localeCompare(b.room_type_code));
    return bucket;
  });
};


/**
 * Copies restrictions to all supported room types after a given column ID in the row.
 * 
 * @param {Array} restrictions - The restrictions to apply.
 * @param {string} colId - The room_type_code after which to apply the restrictions.
 * @param {Object} row - The row object containing the rooms_summary.
 * @returns {Object} - The updated row object.
 */



export const hasAllDatesRecAccepted = (mainData) => {
  let updated = [];
  mainData.forEach(item => {
    let isPastDate = moment(item.date).isBefore(moment().format("YYYY-MM-DD"));
    if (!isPastDate && item.threshold.curr_user_action) {
      if (item.threshold.curr_user_action !== 'recommended_accepted') {
        updated.push(false);
      } else {
        updated.push(true);
      }
    } else if (!isPastDate) {
      updated.push(false);
    }
  });
  if (updated.length && !updated.includes(false)) {
    return true;
  } else {
    return false;
  }
}

export const updateNewBucketData = (buckets, newBuckets) => {
  const restrictionsOrder = ['CTA', 'CTD', 'CLS', 'MN ', 'MX '];
  try {
    buckets.forEach((bucket, i) => {
      bucket.badge_counts.user_updated = newBuckets[i].badge_counts.user_updated;
      bucket.rooms_summary.forEach(room => {
        let newRoom = newBuckets[i].rooms_summary.find(r => r.room_type_code === room.room_type_code);
        room.curr_user_action = newRoom ? newRoom.curr_user_action : room.curr_user_action;
        let isRecAccepted = room.curr_user_action === 'recommended_accepted';
        let isOverridden = room.curr_user_action === 'overridden';

        if (isOverridden) {
          room.restrictions.user_override = [];
          restrictionsOrder.forEach(code => {
            if (['MN ', 'MX '].includes() && newRoom.restrictions.user_override.includes(code)) {
              room.restrictions.user_override.push(code);
            } else {
              const indexOfCode = newRoom.restrictions.user_override.findIndex(r => r.includes(code));
              if (indexOfCode !== -1) {
                room.restrictions.user_override.push(newRoom.restrictions.user_override[indexOfCode]);
              }
            }
          });
        }
      });
      bucket.rate_plans.forEach((ratePlan, ri) => {
        let newRatePlan = newBuckets[i].rate_plans[ri];
        ratePlan.rooms_summary.forEach((room) => {
          let newRoom = newRatePlan.rooms_summary.find(r => r.room_type_code === room.room_type_code);
          room.curr_user_action = newRoom ? newRoom.curr_user_action : room.curr_user_action;
          let isRecAccepted = room.curr_user_action === 'recommended_accepted';
          let isOverridden = room.curr_user_action === 'overridden';

          if (isOverridden) {
            room.restrictions.user_override = [];
            restrictionsOrder.forEach(code => {
              if (['MN ', 'MX '].includes() && newRoom.restrictions.user_override.includes(code)) {
                room.restrictions.user_override.push(code);
              } else {
                const indexOfCode = newRoom.restrictions.user_override.findIndex(r => r.includes(code));
                if (indexOfCode !== -1) {
                  room.restrictions.user_override.push(newRoom.restrictions.user_override[indexOfCode]);
                }
              }
            });
          }
        });
      });
    });
    return buckets;
  } catch (error) {
    console.error('Error updating bucket data:', error);
  }
}
export const copyRestrictionInRow = (restrictions, row, colIndex, roomType, copy) => {
  try {
    const summary = row?.rooms_summary;
    if (!Array.isArray(summary)) return row;

    const startIndex = colIndex; // summary.findIndex(col => col?.room_type_code === colId);
    if (startIndex === -1) return row;
    const colIndexInCurrRow = summary.findIndex(col => col?.room_type_code === roomType);
    let curr_user_action = '';
    summary.forEach((col, i) => {
      if (i > colIndexInCurrRow && col?.restrictions) {
        curr_user_action = summary[i].curr_user_action;
        const override = col?.restrictions?.user_override;
        if (Array.isArray(override)) {
          let current = summary[i].restrictions.current;
          let itemToCopy = copy ? restrictions : restrictions;
          summary[i].copy_row_count = 1;

          if (!itemToCopy.length && col.restrictions) {
            if (copy) {
              col.curr_user_action = summary[colIndexInCurrRow].curr_user_action;
              col.restrictions.user_override = [];
            } else {
              col.curr_user_action = '';
              col.restrictions.user_override = _.cloneDeep(col.restrictions.current);
            }
          }
          itemToCopy.forEach((restriction, idx) => {
            if (restriction.includes('MN ')) {
              if (copy) {
                const hasMn = summary[i].restrictions.user_override.join().includes('MN ');
                if (hasMn) {
                  const indexOfMn = summary[i].restrictions.user_override.findIndex(r => r.includes('MN '));
                  summary[i].restrictions.user_override.splice(indexOfMn, 1, restriction);
                } else {
                  summary[i].restrictions.user_override.push(restriction);
                }
                curr_user_action = 'overridden';
              }
              if (!copy) {
                const hasMn = summary[i].restrictions.user_override.join().includes('MN ');
                const hasCurrMn = summary[i].restrictions.current.join().includes('MN ');
                const indexOfMn = summary[i].restrictions.user_override.findIndex(r => r.includes('MN '));
                if (indexOfMn > -1) {
                  if (hasCurrMn) {
                    const indexOfCurrMn = summary[i].restrictions.current.findIndex(r => r.includes('MN '));
                    const currMnVal = summary[i].restrictions.current[indexOfCurrMn];
                    summary[i].restrictions.user_override.splice(indexOfMn, 1, currMnVal);
                  } else {
                    summary[i].restrictions.user_override.splice(indexOfMn, 1);
                  }
                }
              }
            }

            if (restriction.includes('MX ')) {
              if (copy) {
                const hasMx = summary[i].restrictions.user_override.join().includes('MX ');
                if (hasMx) {
                  const indexOfMx = summary[i].restrictions.user_override.findIndex(r => r.includes('MX '));
                  summary[i].restrictions.user_override.splice(indexOfMx, 1, restriction);
                } else {
                  summary[i].restrictions.user_override.push(restriction);
                }
                curr_user_action = 'overridden';
              }
              if (!copy) {
                const hasMx = summary[i].restrictions.user_override.join().includes('MX ');
                const hasCurrMx = summary[i].restrictions.current.join().includes('MX ');
                const indexOfMx = summary[i].restrictions.user_override.indexOf(restriction);
                if (indexOfMx > -1) {
                  if (hasCurrMx) {
                    const indexOfCurrMx = summary[i].restrictions.current.findIndex(r => r.includes('MX '));
                    const currMxVal = summary[i].restrictions.current[indexOfCurrMx];
                    summary[i].restrictions.user_override.splice(indexOfMx, 1, currMxVal);
                  } else {
                    summary[i].restrictions.user_override.splice(indexOfMx, 1);
                  }
                  // const currMxVal = Number(summary[i].restrictions.user_override[indexOfMx].split(" ")[1]);
                  // const rmMxVal = Number(restriction.split(" ")[1]);
                  // if (currMxVal === rmMxVal) {
                  //   if (!summary[i].restrictions.current.join().includes('MX ')) {
                  //     summary[i].restrictions.user_override.splice(indexOfMx, 1);
                  //   }
                  //   if (summary[i].restrictions.current.join().includes('MX ')) {
                  //     const indexOfCurrMx = summary[i].restrictions.current.findIndex(r => r.includes('MX '));
                  //     const currMxVal = summary[i].restrictions.current[indexOfCurrMx];
                  //     summary[i].restrictions.user_override.splice(indexOfMx, 1, currMxVal);
                  //   }
                  // }
                }
              }
            }

            if (['CTA', 'CTD', 'CLS'].includes(restriction)) {

              if (copy && !summary[i].restrictions.user_override.includes(restriction)) {
                summary[i].restrictions.user_override.splice(idx, 0, restriction);
                curr_user_action = 'overridden';
              }
              if (!copy && summary[i].restrictions.user_override.includes(restriction)) {
                const indexOfRestriction = summary[i].restrictions.user_override.findIndex(r => r === restriction);
                summary[i].restrictions.user_override.splice(indexOfRestriction, 1);
              }
            }
          });
          //summary[i].restrictions.user_override = _.cloneDeep(itemToCopy);
          // if (!copy) {
          //   if (summary[i].restrictions.user_override.join() === current.join()) {
          //     curr_user_action = '';
          //   }
          // }

          // summary[i].curr_user_action = curr_user_action;

          // Sort restrictions after copy
          let restrictionsOrder = ['CTA', 'CTD', 'CLS', 'MN', 'MX'];
          summary[i].restrictions.user_override = summary[i].restrictions.user_override.sort((a, b) => {
            let av = a.split(" ")[0];
            let ai = restrictionsOrder.indexOf(av);
            let bv = b.split(" ")[0];
            let bi = restrictionsOrder.indexOf(bv);
            return ai - bi;
          });
          current = summary[i].restrictions.current.sort((a, b) => {
            let av = a.split(" ")[0];
            let ai = restrictionsOrder.indexOf(av);
            let bv = b.split(" ")[0];
            let bi = restrictionsOrder.indexOf(bv);
            return ai - bi;
          });

          if (summary[i].restrictions.user_override.join() === current.join()) {
            summary[i].curr_user_action = '';
          } else {
            summary[i].curr_user_action = 'overridden';
          }
        }
      }
    });

  } catch (error) {
    console.error(`Error copying restrictions from '${roomType}':`, error);
  }

  return row;
};
export const copyRestrictionInColum = (restrictions, rows, rowIndex, colIndex, roomType, copy) => {
  try {
    // const summary = row?.rooms_summary;
    // if (!Array.isArray(summary)) return row;


    const startIndex = rowIndex; // summary.findIndex(col => col?.room_type_code === colId);
    if (startIndex === -1) return rows;

    rows.forEach((row, i) => {
      if (i > rowIndex) {
        const { MinLOS, MaxLOS } = row.default_restrictions;
        const { is_active } = row;
        let col = row.rooms_summary.find(room => room.room_type_code === roomType);
        if (col?.restrictions && is_active) {
          if (roomType === col?.room_type_code) {
            const override = col?.restrictions?.user_override;
            if (Array.isArray(override)) {
              let current = col.restrictions.current;
              let user = col.restrictions.user_override;
              let itemToCopy = copy ? _.cloneDeep(restrictions) : _.cloneDeep(restrictions);
              let hasMinLos = itemToCopy.join().includes('MN ');
              let hasMaxLos = itemToCopy.join().includes('MX ');
              col.copy_row_count = 1;
              let curr_user_action = '';
              // col.curr_user_action = copy ? 'overridden' : '';

              // if (hasMinLos && MinLOS) {
              //   let indexOfMinLos = itemToCopy.findIndex(r => r.includes('MN '));
              //   let minlos = Number(itemToCopy[indexOfMinLos].split(" ")[1]);
              //   if (minlos < MinLOS) {
              //     itemToCopy.splice(indexOfMinLos, 1, "MN " + MinLOS);
              //   }
              // }
              // if (hasMaxLos && MaxLOS) {
              //   let indexOfMaxLos = itemToCopy.findIndex(r => r.includes('MX '));
              //   let maxlos = Number(itemToCopy[indexOfMaxLos].split(" ")[1]);
              //   if (maxlos > MaxLOS) {
              //     itemToCopy.splice(indexOfMaxLos, 1, "MX " + MaxLOS);
              //   }
              // }

              if (MinLOS) {
                let indexOfMinLos = itemToCopy.findIndex(r => r.includes('MN '));
                // let minlos = Number(itemToCopy[indexOfMinLos].split(" ")[1]);
                if (indexOfMinLos > -1) {
                  itemToCopy.splice(indexOfMinLos, 1);
                }
              }
              if (MaxLOS) {
                let indexOfMaxLos = itemToCopy.findIndex(r => r.includes('MX '));
                // let maxlos = Number(itemToCopy[indexOfMaxLos].split(" ")[1]);
                if (indexOfMaxLos > -1) {
                  itemToCopy.splice(indexOfMaxLos, 1);
                }
              }

              itemToCopy.forEach((restriction, idx) => {
                if (restriction.includes('MN ')) {
                  if (copy) {
                    if (!user.join().includes('MN ')) {
                      col.restrictions.user_override.push(restriction);
                    } else {
                      const indexOfMn = user.findIndex(r => r.includes('MN '));
                      col.restrictions.user_override.splice(indexOfMn, 1, restriction);
                    }
                  }
                  if (!copy && user.join().includes('MN ')) {
                    const indexOfMn = col.restrictions.user_override.findIndex(r => r.includes('MN '));
                    if (!current.join().includes('MN ')) {
                      col.restrictions.user_override.splice(indexOfMn, 1);
                    } else {
                      const indexOfCurrMn = current.findIndex(r => r.includes('MN '));
                      const valueOfCurrMn = current[indexOfCurrMn];
                      col.restrictions.user_override.splice(indexOfMn, 1, valueOfCurrMn);
                    }
                  }

                }

                if (restriction.includes('MX ')) {
                  if (copy) {
                    if (!user.join().includes('MX ')) {
                      col.restrictions.user_override.push(restriction);
                    } else {
                      const indexOfMx = user.findIndex(r => r.includes('MX '));
                      col.restrictions.user_override.splice(indexOfMx, 1, restriction);
                    }
                    // curr_user_action = 'overridden';
                  }
                  if (!copy && user.join().includes('MX ')) {
                    const indexOfMx = col.restrictions.user_override.findIndex(r => r.includes('MX '));
                    if (!current.join().includes('MX ')) {
                      col.restrictions.user_override.splice(indexOfMx, 1);
                    } else {
                      const indexOfCurrMx = current.findIndex(r => r.includes('MX '));
                      const valueOfCurrMx = current[indexOfCurrMx];
                      col.restrictions.user_override.splice(indexOfMx, 1, valueOfCurrMx);
                    }
                  }
                }

                if (['CTA', 'CTD', 'CLS'].includes(restriction)) {
                  if (copy && !col.restrictions.user_override.includes(restriction)) {
                    col.restrictions.user_override.push(restriction);
                    // curr_user_action = 'overridden';
                  }
                  if (!copy && user.includes(restriction)) {
                    const indexOfRest = user.indexOf(restriction);
                    if (!current.includes(restriction)) {
                      col.restrictions.user_override.splice(indexOfRest, 1);
                    } else {
                      const indexOfCurrRest = current.indexOf(restriction);
                      const currRestVal = current[indexOfCurrRest];
                      col.restrictions.user_override.splice(indexOfRest, 1, currRestVal);
                    }
                  }
                }
              });

              if (!itemToCopy.length && col.restrictions) {
                let copyCol = rows[rowIndex].rooms_summary.find(room => room.room_type_code === roomType);
                col.curr_user_action = col.restrictions.user_override.length ? 'overridden' : '';
                if (!MinLOS) {
                  if (copy) {
                    col.restrictions.user_override = [];
                  } else {
                    // col.curr_user_action = '';
                    col.restrictions.user_override = _.cloneDeep(col.restrictions.current);
                  }
                } else {
                  if (copy) {
                    const valueOfMn = col.restrictions.user_override.find(itm => itm.includes('MN '));
                    col.restrictions.user_override = [];
                    if (valueOfMn) {
                      col.restrictions.user_override = [valueOfMn];
                    }
                  } else {
                    col.curr_user_action = '';
                    col.restrictions.user_override = _.cloneDeep(col.restrictions.current);
                  }
                }
              }

              // Sort restrictions after copy
              // col.curr_user_action = curr_user_action;
              let restrictionsOrder = ['CTA', 'CTD', 'CLS', 'MN', 'MX'];
              col.restrictions.user_override = col.restrictions.user_override.sort((a, b) => {
                let av = a.split(" ")[0];
                let ai = restrictionsOrder.indexOf(av);
                let bv = b.split(" ")[0];
                let bi = restrictionsOrder.indexOf(bv);
                return ai - bi;
              });
              current = current.sort((a, b) => {
                let av = a.split(" ")[0];
                let ai = restrictionsOrder.indexOf(av);
                let bv = b.split(" ")[0];
                let bi = restrictionsOrder.indexOf(bv);
                return ai - bi;
              });
              if (col.restrictions.user_override.join() === current.join()) {
                col.curr_user_action = '';
              } else {
                col.curr_user_action = 'overridden';
              }
              //col.restrictions.user_override = _.cloneDeep(itemToCopy);
            }
          }
        }
      }
    });

  } catch (error) {
    console.error(`Error copying restrictions from '${roomType}':`, error);
  }

  return rows;
};

export const getEffectedDates = ({ mainData = [], app_state }) => {
  let effectedDates = _.cloneDeep(app_state?.plrDatesToPush) || [];
  mainData.forEach(item => {
    const isPastDate = moment(item.date).isBefore(moment().format("YYYY-MM-DD"));
    if (!isPastDate) {
      const isRecAccepted = item.threshold.curr_user_action === 'recommended_accepted';
      const isOverridden = item.threshold.curr_user_action === 'overridden';
      if (item.threshold.curr_user_action && !effectedDates.includes(item.date)) {
        effectedDates.push(item.date);
      }
      if (!item.threshold.curr_user_action && effectedDates.includes(item.date)) {
        const index = effectedDates.indexOf(item.date);
        if (index > -1) effectedDates.splice(index, 1);
      }

      if (item.buckets.length) {
        let status = getRestrictionsUpdateStatus(item.buckets);
        if (status && !effectedDates.includes(item.date)) {
          effectedDates.push(item.date);
        }
        if (!status && effectedDates.includes(item.date)) {
          let indexRemove = effectedDates.indexOf(item.date);
          effectedDates.splice(indexRemove, 1);
          item.threshold.curr_user_action = '';
        }
      }
    }
  });
  return effectedDates;
}

export const allRatePlanHasRecAccepted = (buckets, roomType) => {
  let updated = [];
  buckets.forEach((bucket) => {
    bucket.rooms_summary.forEach(room => {
      let isRecAccepted = room.curr_user_action === 'recommended_accepted';
      if (roomType && room.room_type_code === roomType) {
        const recommended = room.restrictions.recommended.join();
        if (recommended) {
          updated.push(isRecAccepted);
        }
      }
      if (!roomType) {
        const recommended = room.restrictions.recommended.join();
        if (recommended) {
          updated.push(isRecAccepted);
        }
      }
    });
    bucket.rate_plans.forEach(ratePlan => {
      ratePlan.rooms_summary.forEach(room => {
        let isRecAccepted = room.curr_user_action === 'recommended_accepted';
        if (roomType && room.room_type_code === roomType) {
          const recommended = room.restrictions.recommended.join();
          if (recommended) {
            updated.push(isRecAccepted);
          }
        }
        if (!roomType) {
          const recommended = room.restrictions.recommended.join();
          if (recommended) {
            updated.push(isRecAccepted);
          }
        }
      });
    });
  });
  if (updated.length && !updated.includes(false)) {
    return true;
  } else {
    return false;
  }
}

export const isAnyRestrictionsAltered = (buckets) => {
  let updated = false;
  buckets.forEach((bucket) => {
    if (!updated) {
      bucket.rooms_summary.forEach(room => {
        if (!updated) {
          let current = room?.restrictions?.current?.join();
          let user = room?.restrictions?.user_override.join();
          if (room.curr_user_action) {
            //updated = true;
            //updated.push(true);
          }
          if (user !== current) {
            updated = true;
          }
        }
      });
      bucket.rate_plans.forEach(ratePlan => {
        if (!updated) {
          ratePlan.rooms_summary.forEach(room => {
            if (!updated) {
              let current = room?.restrictions?.current?.join();
              let user = room?.restrictions?.user_override?.join();
              if (room.curr_user_action) {
                //updated = true;
              }
              if (user !== current) {
                updated = true;
              }
            }
          });
        }
      });
    }
  });

  return updated
}

export const compareBuckets = (buckets = [], newBuckets = []) => {
  let updated = false;
  buckets.forEach((bucket, bi) => {
    if (!updated) {
      // bucket.rooms_summary.forEach((room, rti) => {
      //   if (!updated) {
      //     let user = room.restrictions && room.restrictions.user_override.length ? room.restrictions.user_override.join() : null;
      //     let userNew = newBuckets[bi].rooms_summary[rti].restrictions.user_override.join();
      //     if (user !== userNew) {
      //       updated.push(true);
      //     }
      //   }
      // });
      bucket.rate_plans.forEach((ratePlan, rpi) => {
        ratePlan.rooms_summary.forEach((room, rti) => {
          if (!updated) {
            let current = room?.restrictions?.current?.join();
            let user = room?.restrictions?.user_override?.join();
            // let userNew = newBuckets[bi].rate_plans[rpi]?.rooms_summary[rti]?.restrictions?.user_override?.join();
            if (user !== current) {
              updated = true;
            }
          }
        });
      });
    }
  });
  return updated;
}

export const anyRatePlanHasOverriden = (buckets, roomType) => {
  let updated = [];
  buckets.forEach((bucket) => {
    bucket.rooms_summary.forEach(room => {
      let isRecAccepted = room.curr_user_action === 'recommended_accepted';
      let isOverridden = room.curr_user_action === 'overridden';
      if (roomType && room.room_type_code === roomType) {
        updated.push(isOverridden);
      }
      if (!roomType) {
        updated.push(isOverridden);
      }
    });
    bucket.rate_plans.forEach(ratePlan => {
      ratePlan.rooms_summary.forEach(room => {
        let isRecAccepted = room.curr_user_action === 'recommended_accepted';
        let isOverridden = room.curr_user_action === 'overridden';
        if (roomType && room.room_type_code === roomType) {
          updated.push(isOverridden);
        }
        if (!roomType) {
          updated.push(isOverridden);
        }
      });
    });
  });
  if (updated.length && updated.includes(true)) {
    return true;
  } else {
    return false;
  }
}
export const getRestrictionsUpdateStatus = (buckets) => {
  let updated = [];
  buckets.forEach((bucket) => {
    bucket.rooms_summary.forEach(room => {
      if (room.curr_user_action) updated.push(true);
    });
    bucket.rate_plans.forEach(ratePlan => {
      ratePlan.rooms_summary.forEach(room => {
        if (room.curr_user_action) updated.push(true);
      });
    });
  });
  if (updated.includes(true)) {
    return true;
  } else {
    return false;
  }
}
export const toggleBucketsRecRestriction = (buckets, accept = false) => {
  let newBuckets = _.cloneDeep(buckets);
  newBuckets.forEach(bucket => {
    // bucket.rec_accepted = accept;
    bucket.curr_user_action = accept ? 'recommended_accepted' : '';
    bucket.rooms_summary.forEach(room => {
      if (room.restrictions.recommended.length) {
        // room.rec_accepted = accept;
        room.curr_user_action = accept ? 'recommended_accepted' : '';
        // if (accept) room.restrictions.user_override = _.cloneDeep(room.restrictions.recommended);
        // if (!accept) room.restrictions.user_override = _.cloneDeep(room.restrictions.current);
      } else {
        room.curr_user_action = '';
        // room.restrictions.user_override = _.cloneDeep(room.restrictions.current);
      }
    });
    bucket.rate_plans.forEach(ratePlans => {
      ratePlans.rooms_summary.forEach(room => {
        if (room.restrictions.recommended.length) {
          // room.rec_accepted = accept;
          room.curr_user_action = accept ? 'recommended_accepted' : '';
          // if (accept) room.restrictions.user_override = _.cloneDeep(room.restrictions.recommended);
          // if (!accept) room.restrictions.user_override = _.cloneDeep(room.restrictions.current);
        } else {
          room.curr_user_action = '';
          // room.restrictions.user_override = _.cloneDeep(room.restrictions.current);
        }
      });
    });
  });
  return newBuckets;
}

export const resetBucketsData = (buckets) => {
  let newBuckets = _.cloneDeep(buckets);
  newBuckets.forEach(bucket => {
    // bucket.rec_accepted = accept;
    bucket.badge_counts.user_updated = bucket.badge_counts.initial;
    bucket.curr_user_action = '';
    bucket.rooms_summary.forEach(room => {
      room.curr_user_action = '';
      room.restrictions.user_override = _.cloneDeep(room.restrictions.current);
      //Reset copied status
      room.copiedRight = false;
      room.copiedDown = false;
    });
    bucket.rate_plans.forEach(ratePlans => {
      ratePlans.rooms_summary.forEach(room => {
        room.curr_user_action = '';
        room.restrictions.user_override = _.cloneDeep(room.restrictions.current);
        //Reset copied status
        room.copiedRight = false;
        room.copiedDown = false;
      });
    });
  });
  return newBuckets;
}

export const cleanBucketsData = (buckets) => {
  let newBuckets = _.cloneDeep(buckets);
  newBuckets.forEach(bucket => {
    // bucket.rec_accepted = accept;
    bucket.rooms_summary.forEach(room => {
      //Reset copied status
      delete room.copiedRight;
      delete room.copiedDown;
      delete room.showCopyMenu;
    });
    bucket.rate_plans.forEach(ratePlans => {
      ratePlans.rooms_summary.forEach(room => {
        //Reset copied status
        delete room.copiedRight;
        delete room.copiedDown;
        delete room.showCopyMenu;
      });
    });
  });
  return newBuckets;
}

export const changeBucketsUserAction = (buckets, prevUserAction = "") => {
  let newBuckets = _.cloneDeep(buckets);
  newBuckets.forEach(bucket => {
    // bucket.rec_accepted = accept;
    bucket.badge_counts.user_updated = bucket.badge_counts.initial;
    bucket.curr_user_action = '';
    bucket.pre_user_action = prevUserAction;
    bucket.rooms_summary.forEach(room => {
      room.curr_user_action = '';
      room.pre_user_action = prevUserAction;
      room.restrictions.user_override = _.cloneDeep(room.restrictions.user_override);
      //Reset copied status
      room.copiedRight = false;
      room.copiedDown = false;
    });
    bucket.rate_plans.forEach(ratePlans => {
      ratePlans.rooms_summary.forEach(room => {
        room.curr_user_action = '';
        room.pre_user_action = prevUserAction;
        room.restrictions.user_override = _.cloneDeep(room.restrictions.user_override);
        //Reset copied status
        room.copiedRight = false;
        room.copiedDown = false;
      });
    });
  });
  return newBuckets;
}

export const isRestrictionEdited = (buckets, restriction = 'MN ') => {
  let newBuckets = _.cloneDeep(buckets);
  let isEdited = false;
  newBuckets.forEach(bucket => {
    // bucket.rec_accepted = accept;
    bucket.badge_counts.user_updated = bucket.badge_counts.initial;
    bucket.curr_user_action = '';
    bucket.rooms_summary.forEach(room => {
      if (!isEdited) {
        const { current, user_override } = room.restrictions;
        let currMinLos = null;
        let userMinLos = null;
        if (current.join().includes(restriction)) {
          const indexOfMinLos = current.findIndex(r => r.includes(restriction));
          currMinLos = Number(current[indexOfMinLos].split(" ")[1]);
        }
        if (user_override.join().includes(restriction)) {
          const indexOfUserMinLos = user_override.findIndex(r => r.includes(restriction));
          userMinLos = Number(user_override[indexOfUserMinLos].split(" ")[1]);
        }
        if (currMinLos !== userMinLos) {
          isEdited = true;
        }
      }
    });
    bucket.rate_plans.forEach(ratePlans => {
      ratePlans.rooms_summary.forEach(room => {
        if (!isEdited) {
          const { current, user_override } = room.restrictions;
          let currMinLos = null;
          let userMinLos = null;
          if (current.join().includes(restriction)) {
            const indexOfMinLos = current.findIndex(r => r.includes(restriction));
            currMinLos = Number(current[indexOfMinLos].split(" ")[1]);
          }
          if (user_override.join().includes(restriction)) {
            const indexOfUserMinLos = user_override.findIndex(r => r.includes(restriction));
            userMinLos = Number(user_override[indexOfUserMinLos].split(" ")[1]);
          }
          if (currMinLos !== userMinLos) {
            isEdited = true;
          }
        }
      });
    });
  });
  return isEdited;
}
